import { render, staticRenderFns } from "./moduleHeader.vue?vue&type=template&id=cff98f08&scoped=true&"
import script from "./moduleHeader.vue?vue&type=script&lang=js&"
export * from "./moduleHeader.vue?vue&type=script&lang=js&"
import style0 from "./moduleHeader.vue?vue&type=style&index=0&id=cff98f08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff98f08",
  null
  
)

export default component.exports